import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { PLANS } from '@/enums/Plan';

export function usePlan() {
    const page = usePage();

    const plan = computed(() => page.props.auth.user?.plan ?? PLANS.FREE);
    const isPaid = computed(() => plan.value === PLANS.ORGANIZER);
    const isFree = computed(() => !isPaid.value);
    const onGracePeriod = computed(() => page.props.auth.user?.on_grace_period ?? false);
    const subscriptionEndsAt = computed(() => page.props.auth.user?.subscription_ends_at ?? null);
    const subscriptionStartedAt = computed(
        () => page.props.auth.user?.subscription_started_at ?? null,
    );
    const subscriptionStatus = computed(() => page.props.auth.user?.subscription_status ?? null);
    const subscriptionInterval = computed(
        () => page.props.auth.user?.subscription_interval ?? null,
    );
    const trialEndsAt = computed(() => page.props.auth.user?.trial_ends_at ?? null);

    return {
        plan,
        isPaid,
        isFree,
        onGracePeriod,
        subscriptionEndsAt,
        subscriptionStartedAt,
        subscriptionStatus,
        subscriptionInterval,
        trialEndsAt,
    };
}
